import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {config} from '../../../../config';
import Icon from '../../../components/Icon';
import ProfilForumList from './ProfileForumList';
import {Button} from "../../../components/Button";
import {bindActionCreators} from "redux";
import Modal from "../../../components/Modal";
import createLink from "../../../../libs/createLink";
import _ from "lodash";
import BannerMeet from "./bannedMeet/BannedMeet";

class ProfileInformations extends React.Component {

    render() {
        return (
            <div className="wrapper-profil-informations">
                {_.get(this.props.user,"setting.appearInDating") || this.props.isMe ? (
                    <div className="main-wrapper">
                        <div className="card big">
                            {this.props.isMe &&
                                <Button className={"mb-8 mt-8 full"}
                                        size={"small"}
                                        btnStyle={"edit"}
                                        icon={"pencil"}
                                        to={createLink("userMeSettingsDating")}
                                        content={"Editer"}/>
                            }
                            {this.props.articlesCount >= 1 && (
                                <Fragment>
                                    <div
                                        className={`informations-container last-forum-post full ${!this.props.isMe && 'mt-0'}`}>
                                        <h5 className="title display-5  full">
                                            Dernière publication de rencontre
                                        </h5>
                                        <div className="last-forum-post-wrapper row wrap">
                                            {/*{this.props.articles.map((item, index) => {*/}
                                            {/*let departement = item.breadcrumb.slice(3, 4)[0];*/}
                                            {/*let forum = item.breadcrumb.slice(2, 3)[0];*/}
                                            {/*return (*/}
                                            {/*<div key={index} className="last-forum-card column">*/}
                                            {/*<Title heading={"heading-4"} display={"display-5"}*/}
                                            {/*className="title"><Link*/}
                                            {/*to={`/topic/${item._id}-${item.slug}`}>{item.title}</Link>*/}
                                            {/*</Title>*/}
                                            {/*<div className="row full align-center">*/}
                                            {/*<Link to={departement && departement.link || ""}*/}
                                            {/*className="mr-16 link">{departement && departement.name || ""}</Link>*/}
                                            {/*<span><DateSince date={item.createdAt}/></span>*/}
                                            {/*</div>*/}
                                            {/*</div>*/}
                                            {/*)*/}
                                            {/*})}*/}
                                        </div>
                                    </div>
                                    <Modal toggle={this.state.toggleForumList}
                                           handleClose={() => this.setState({toggleForumList: false})}>
                                        <ProfilForumList userId={this.props.user._id}
                                                         handleClose={() => this.setState({toggleForumList: false})}/>
                                    </Modal>
                                </Fragment>
                            )}
                            {_.get(this.props,"user.profile.description") && this.props.user.profile.description.length >0 ? (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">A propos de moi </h5>
                                    <div className="content">
                                        {this.props.user.profile.description}
                                    </div>
                                </div>
                            ) : null}
                            {this.props.user.profile && this.props.user.profile.lookingFor && this.props.user.profile.lookingFor.length >0 ? (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">Recherche</h5>
                                    <div className="content">
                                        {this.props.user.profile.lookingFor !== null && this.props.user.profile.lookingFor.map((lookingFor, index) => (
                                            lookingFor !== 0 ? <span key={index}>
                                        {config.lookingFor[lookingFor]}
                                    </span> : null
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {!this.props.isMe && _.get(this.props.user, "setting.appearInDating")
                            ? <BannerMeet
                                _id={_.get(this.props.user, "_id")}
                                username={_.get(this.props.user, "username") || ""}
                                slug={_.get(this.props.user, "slug") || ""}
                                avatar={_.get(this.props.user, "profile.avatar") || ""}
                                gender={_.get(this.props.user, "profile.gender") || 0}
                            />
                            : null
                        }

                        <div className="card big">
                            {this.props.user.profile && this.props.user.profile.tendencies && this.props.user.profile.tendencies.length >0 ? (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">Tendance</h5>
                                    <div className="content">
                                        {this.props.user.profile.tendencies !== null && this.props.user.profile.tendencies.map((tendencies, index) => (
                                            tendencies !== 0 ? <span key={index}>
                                        {config.tendencies[tendencies]}
                                    </span> : null
                                        ))}
                                    </div>
                                </div>
                            ) : null}

                            {this.props.user.profile && this.props.user.profile.mobility ?  (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">Mobilité</h5>
                                    <div className="content">
                                        {config.mobility[this.props.user.profile.mobility]}
                                    </div>
                                </div>
                            ) : null}

                            {this.props.user.profile && this.props.user.profile.civilStatus ?  (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">Statut marital</h5>
                                    <div className="content">
                                        {config.civilStatus[this.props.user.profile.civilStatus]}
                                    </div>
                                </div>
                            ) : null}


                            {this.props.user.location.country && this.props.user.location.country._id && this.props.user.location.country._id.length > 0 && (
                                <div className="informations-container looking-for full">
                                    <h5 className="title display-5 full">Localisation</h5>
                                    <div className="content location">
                                        <span className="py-4">{this.props.user.location.country.name}</span>
                                        {this.props.user.location.region && this.props.user.location.region._id.length > 0 &&
                                            <span className="py-4">{this.props.user.location.region.name}</span>}
                                        {this.props.user.location.county && this.props.user.location.county._id.length > 0 &&
                                            <span className="py-4">{this.props.user.location.county.name}</span>}
                                        {this.props.user.location.city && this.props.user.location.city._id.length > 0 &&
                                            <span className="py-4">{this.props.user.location.city.name}</span>}
                                    </div>
                                </div>
                            )}
                            {this.props.user.profile.informations.length > 0 && (
                                <div className="informations-container full">
                                    <h5 className="title display-5  full">Si vous étiez</h5>
                                    <div className={"flex-table"}>
                                        <div className={"row flex-1"}>
                                            {this.props.user.profile.informations.map((informations, index) => (
                                                <div key={index}
                                                     className={`column flex-table-column ${this.props.user.profile.informations.length === 1 ? 'single' : ''}`}>
                                                    {this.props.user.profile.informations.length === 2 && (
                                                        <div className="flex-table-content">
                                                            <div key={index}
                                                                 className={`flex-table-head-title ${informations.sex === 0 ? 'him' : informations.sex === 1 ? 'her' : ''}`}>
                                                                <Icon type={config.genderClassProfile[informations.sex]}/>
                                                                {informations.sex === 0 ? (
                                                                    "Lui"
                                                                ) : informations.sex === 1 && (
                                                                    "Elle"
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Une position sexuelle</div>
                                                        {informations.sexualPosition ? config.sexualPosition[informations.sexualPosition] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Un objet fétichiste</div>
                                                        {informations.fetishObject ? config.fetishObject[informations.fetishObject] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Une partie de son corps</div>
                                                        {informations.partnerBodyPart ? config.bodyPart[informations.partnerBodyPart] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Une partie de votre corps</div>
                                                        {informations.bodyPart ? config.bodyPart[informations.bodyPart] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Un lieu où faire l'amour</div>
                                                        {informations.placeToHaveFetishSex ? config.placeToHaveFetishSex[informations.placeToHaveFetishSex] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Taille</div>
                                                        {informations.size ? config.size[informations.size] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Poids</div>
                                                        {informations.weight ? config.weight[informations.weight] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Yeux</div>
                                                        {informations.eyesColor ? config.eyesColor[informations.eyesColor] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Cheveux</div>
                                                        {informations.hairColor ? config.hairColor[informations.hairColor] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Look</div>
                                                        {informations.lookStyle ? config.lookStyle[informations.lookStyle] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Pilosité</div>
                                                        {informations.hairiness ? config.hairiness[informations.hairiness] : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Personnalité</div>
                                                        {informations.personality.length > 0 ? informations.personality.map((personalityMap, index) => (
                                                            <span className={"my-4"}
                                                                  key={index}>{config.personality[personalityMap]}</span>
                                                        )) : 'Non renseigné'}
                                                    </div>
                                                    <div className="flex-table-content">
                                                        <div className={"flex-table-label"}>Fumeur</div>
                                                        {informations.smoker ? config.smoker[informations.smoker] : 'Non renseigné'}
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="main-wrapper">
                        <div className="card big">
                            <span className={"flex-jc-c"}>Ce membre ne souhaite pas faite de rencontres.</span>
                            <BannerMeet
                                _id={_.get(this.props.user, "_id")}
                                username={_.get(this.props.user, "username") || ""}
                                slug={_.get(this.props.user, "slug") || ""}
                                avatar={_.get(this.props.user, "profile.avatar") || ""}
                                gender={_.get(this.props.user, "profile.gender") || 0}
                                />
                        </div>
                    </div>
                )}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // articles: stateArticles.articles.list,
        // articlesCount: stateArticles.articles.count,
        // articlesLoading: stateArticles.articles.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    // getArticlesDating
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ProfileInformations);
